// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"313":"MatchStats","443":"about"}[chunkId] + "." + {"313":"0df7f5cc","443":"0866cf9d"}[chunkId] + ".js";
};